/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Practice_Session_Audio_Device_SpeakerInputs */



/**
* | output |
* | --- |
* | "Speaker {index}" |
*
* @param {Practice_Session_Audio_Device_SpeakerInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_audio_device_speaker = /** @type {((inputs: Practice_Session_Audio_Device_SpeakerInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Audio_Device_SpeakerInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Luidspreker ${i?.index}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Haut-parleur ${i?.index}`)
	return /** @type {LocalizedString} */ (`Speaker ${i?.index}`)
});